'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _influencer__box = require('./influencer__box.vue');

var _influencer__box2 = _interopRequireDefault(_influencer__box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            posts: [],
            postsPerPage: 4,
            resultCount: 0
        };
    },
    ready: function ready() {
        this.fetchData();
    },

    methods: {
        fetchData: function fetchData() {
            this.$http.get('assets/js/posts.json').then(function (response) {
                this.$set('posts', response.data.posts);
                this.$set('resultCount', response.data.posts.length);
            });
        },
        loadMore: function loadMore(event) {
            var newValue = this.postsPerPage + 4;
            if (this.resultCount < newValue) {
                event.target.classList.add('is-hidden');
            }
            return this.$set('postsPerPage', newValue);
        }
    },
    components: {
        influencerBox: _influencer__box2.default
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n    <div class=\"stream__grid\">\n        <influencer-box v-for=\"post in posts | orderBy 'id' -1  | limitBy postsPerPage\" :post=\"post\"></influencer-box>\n    </div>\n<p class=\"text-center\">\n    <button @click.stop=\"loadMore\" class=\"button button--ghost\">Load More</button>\n</p>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-138e56bc", module.exports)
  } else {
    hotAPI.update("_v-138e56bc", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}